(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('pagarmeRecipientForm', {
            templateUrl: 'app/admin/settings/payments/components/pagarme-recipient-form/pagarme-recipient-form.html',
            bindings: {
                recipient: '=',
                formCtrl: '=',
                onSaved: '&',
                onCancel: '&'
            },
            controller: pagarmeRecipientFormController
        });

    pagarmeRecipientFormController.$inject = ['$scope', '$q', '$translate', 'toastr', '$uibModal',
        'PaymentSetupService', 'BankDataService', 'PagarMeV5Service', 'pagarmeConstants', 'PagarmeUtilsService', 'cpfCnpjFilterConstants'];

    function pagarmeRecipientFormController($scope, $q, $translate, toastr, $uibModal,
        PaymentSetupService, BankDataService, PagarMeV5Service, pagarmeConstants, PagarmeUtilsService, cpfCnpjFilterConstants) {
        var $ctrl = this;

        var IGNORED_FIELDS_ON_EDIT = ['documentNumber', 'holderDocument'];
        var VALID_TRANSFER_INTERVALS = [pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.WEEKLY, pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.MONTHLY];

        $ctrl.pagarmeConstants = pagarmeConstants;
        $ctrl.occupations = PaymentSetupService.getProfessionalOccupations();
        $ctrl.transferDaysWeekly = buildTransferDaysWeekly();
        $ctrl.transferDaysMonthly = buildTransferDaysMonthly();
        $ctrl.customerTypeOptions = [
            { value: pagarmeConstants.RECIPIENT_TYPE.INDIVIDUAL, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.individual') },
            { value: pagarmeConstants.RECIPIENT_TYPE.CORPORATION, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.corporation') }
        ];
        $ctrl.bankAccountTypeOptions = [
            { value: pagarmeConstants.BANK_ACCOUNT_TYPE_OPTIONS.CONTA_CORRENTE, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.contaCorrente') },
            { value: pagarmeConstants.BANK_ACCOUNT_TYPE_OPTIONS.CONTA_POUPANCA, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.contaPoupanca') }
        ];
        $ctrl.transferIntervalOptions = [
            { value: pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.WEEKLY, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.weekly') },
            { value: pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.MONTHLY, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.monthly') }
        ];
        $ctrl.selectedBank = null;
        $ctrl.bankSearchText = '';
        $ctrl.isSaving = false;
        $ctrl.addressModel = {};
        $ctrl.birthdateDisplay = null;
        $ctrl.monthlyIncomeDisplay = null;
        $ctrl.annualRevenueDisplay = null;
        $ctrl.branchNumberModel = {};
        $ctrl.accountNumberModel = {};

        $scope.$watch(function () {
            return $ctrl.selectedBank;
        }, function (bank) {
            if (bank) {
                $ctrl.recipient.bankAccount.bankCode = bank.code;
            }
        });

        $ctrl.$onInit = function () {
            $ctrl.formCtrl = $ctrl;
            if (!$ctrl.recipient.registerInformation) {
                $ctrl.recipient.registerInformation = {};
            }
            if ($ctrl.isCreate() && !$ctrl.recipient.registerInformation.type) {
                $ctrl.recipient.registerInformation.type = pagarmeConstants.RECIPIENT_TYPE.INDIVIDUAL;
            }
            updateBankAccountType();
            if (!$ctrl.recipient.registerInformation.address) {
                $ctrl.recipient.registerInformation.address = {};
            }
            syncAddressModelFromRecipient();
            syncDatesFromRecipient();
            syncMonetaryFromRecipient();
            syncBankAccountNumbersFromRecipient();
            initTransferSettings();
            if ($ctrl.recipient.bankAccount && $ctrl.recipient.bankAccount.bankCode) {
                hydrateSelectedBank($ctrl.recipient.bankAccount.bankCode);
            }
        };

        $ctrl.$onChanges = function (changes) {
            if (changes.recipient && !changes.recipient.isFirstChange()) {
                syncAddressModelFromRecipient();
                syncDatesFromRecipient();
                syncMonetaryFromRecipient();
                syncBankAccountNumbersFromRecipient();
                initTransferSettings();
                if ($ctrl.recipient.bankAccount && $ctrl.recipient.bankAccount.bankCode) {
                    hydrateSelectedBank($ctrl.recipient.bankAccount.bankCode);
                }
            }
        };

        $ctrl.updateBankAccountType = updateBankAccountType;

        $ctrl.onTransferIntervalChange = function () {
            $ctrl.recipient.transferDay = 1;
        };

        $ctrl.getDocumentMaskType = function () {
            return $ctrl.recipient.registerInformation.type === pagarmeConstants.RECIPIENT_TYPE.CORPORATION
                ? cpfCnpjFilterConstants.TYPE.CNPJ
                : cpfCnpjFilterConstants.TYPE.CPF;
        };

        $ctrl.isEdit = function () {
            return !!($ctrl.recipient && $ctrl.recipient.recipientId);
        };

        $ctrl.isCreate = function () {
            return !$ctrl.isEdit();
        };

        $ctrl.querySearchBank = function (searchText) {
            var defer = $q.defer();
            BankDataService.findBanks(searchText === undefined ? '' : searchText, 0, 10).then(
                function (response) {
                    var banks = (response.data || []).map(function (bank) {
                        bank.displayLabel = bank.code + ' - ' + bank.name;
                        return bank;
                    });
                    defer.resolve(banks);
                },
                function () { defer.resolve([]); }
            );
            return defer.promise;
        };

        $ctrl.openManagingPartnerModal = function () {
            openManagingPartnerModal(undefined, undefined);
        };

        $ctrl.updateManagingPartner = function (partnerIndex, partner) {
            openManagingPartnerModal(partnerIndex, partner);
        };

        $ctrl.removeManagingPartner = function (partnerIndex, partner) {
            if ($ctrl.recipient.registerInformation && $ctrl.recipient.registerInformation.managingPartners) {
                $ctrl.recipient.registerInformation.managingPartners = $ctrl.recipient.registerInformation.managingPartners
                    .filter(function (item, index) { return partnerIndex !== index; });
            }
        };

        $ctrl.cancel = function () {
            $ctrl.onCancel();
        };

        $ctrl.save = function () {
            syncAddressModelToRecipient();
            syncDatesToRecipient();
            syncMonetaryToRecipient();
            syncBankAccountNumbersToRecipient();

            if (hasBlockingErrors()) {
                toastr.warning($translate.instant('error.invalid-fields'));
                return;
            }

            if ($ctrl.recipient.registerInformation.type === pagarmeConstants.RECIPIENT_TYPE.CORPORATION) {
                if (!$ctrl.recipient.registerInformation.managingPartners
                    || $ctrl.recipient.registerInformation.managingPartners.length === 0) {
                    toastr.warning($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.managingPartnersRequired'));
                    return;
                }
            }

            $ctrl.isSaving = true;
            var savePromise = $ctrl.isEdit()
                ? PagarMeV5Service.updateRecipient($ctrl.recipient)
                : PagarMeV5Service.integrateRecipient($ctrl.recipient);

            savePromise.then(
                function () {
                    $ctrl.isSaving = false;
                    toastr.success($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.success'));
                    $ctrl.onSaved();
                },
                function (error) {
                    $ctrl.isSaving = false;
                    var errorMessageKey = error && error.data && error.data.data && error.data.data.message;
                    var errorMessageTranslationKey = 'settings.store.payments.tabs.pagarMe.recipientForm.' + errorMessageKey;
                    var translatedMessage = errorMessageKey ? $translate.instant(errorMessageTranslationKey) : errorMessageKey;
                    var hasTranslatedMessage = !!errorMessageKey && translatedMessage !== errorMessageTranslationKey;
                    if (hasTranslatedMessage) {
                        toastr.error(translatedMessage);
                    } else if (error && error.data && error.data.headers && error.data.headers.statuskey) {
                        toastr.error($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.' + error.data.headers.statuskey));
                    } else {
                        toastr.error($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.error'));
                    }
                }
            );
        };

        function buildTransferDaysMonthly() {
            var days = [];
            for (var i = 1; i <= 31; i++) {
                days.push({ value: i, label: '' + i });
            }
            return days;
        }

        function buildTransferDaysWeekly() {
            return [
                { value: 1, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.monday') },
                { value: 2, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.tuesday') },
                { value: 3, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.wednesday') },
                { value: 4, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.thursday') },
                { value: 5, label: $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.friday') }
            ];
        }

        function initTransferSettings() {
            $ctrl.recipient.transferEnabled = true;

            var isValidInterval = VALID_TRANSFER_INTERVALS.includes($ctrl.recipient.transferInterval);

            if (!isValidInterval) {
                $ctrl.recipient.transferInterval = pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.MONTHLY;
            }

            if (!$ctrl.recipient.transferDay) {
                $ctrl.recipient.transferDay = 1;
            }
        }

        function updateBankAccountType() {
            if (!$ctrl.recipient.bankAccount) {
                $ctrl.recipient.bankAccount = {};
            }
            $ctrl.recipient.bankAccount.holderType = $ctrl.recipient.registerInformation.type === pagarmeConstants.RECIPIENT_TYPE.CORPORATION
                ? pagarmeConstants.BANK_ACCOUNT_TYPE.COMPANY
                : pagarmeConstants.BANK_ACCOUNT_TYPE.INDIVIDUAL;
            $ctrl.recipient.bankAccount.holderDocument = $ctrl.recipient.registerInformation.documentNumber;
        }

        function hasBlockingErrors() {
            var ignoredFields = $ctrl.isEdit() ? IGNORED_FIELDS_ON_EDIT : [];
            var blocking = false;
            angular.forEach($ctrl.recipientForm.$error, function (controls) {
                angular.forEach(controls, function (control) {
                    if (ignoredFields.indexOf(control.$name) === -1) {
                        blocking = true;
                        control.$setTouched();
                    }
                });
            });
            return blocking;
        }

        function hydrateSelectedBank(bankCode) {
            BankDataService.findBanks(bankCode, 0, 1).then(function (response) {
                if (response.data && response.data.length > 0) {
                    var bank = response.data[0];
                    bank.displayLabel = bank.code + ' - ' + bank.name;
                    $ctrl.selectedBank = bank;
                }
            });
        }

        function openManagingPartnerModal(partnerIndex, partner) {
            $uibModal.open({
                templateUrl: 'app/admin/settings/payments/pagarme/modal/add-managing-partner-modal.html',
                controller: 'AddManagingPartnerController',
                windowClass: 'side-modal side-modal-top',
                controllerAs: 'vm',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    partner: function () { return partner; },
                    partnerIndex: function () { return partnerIndex; }
                }
            }).result.then(function (response) {
                if (response.data) {
                    if (!$ctrl.recipient.registerInformation.managingPartners) {
                        $ctrl.recipient.registerInformation.managingPartners = [];
                    }
                    if (response.data.partnerIndex !== undefined) {
                        $ctrl.recipient.registerInformation.managingPartners[response.data.partnerIndex] = response.data.partner;
                    } else {
                        $ctrl.recipient.registerInformation.managingPartners.push(response.data.partner);
                    }
                }
            });
        }

        function syncAddressModelFromRecipient() {
            $ctrl.addressModel = PagarmeUtilsService.toAddressComponentModel($ctrl.recipient.registerInformation.address);
        }

        function syncAddressModelToRecipient() {
            $ctrl.recipient.registerInformation.address = PagarmeUtilsService.toAddressDTO(
                $ctrl.addressModel, $ctrl.recipient.registerInformation.address);
        }

        function syncDatesFromRecipient() {
            $ctrl.birthdateDisplay = PagarmeUtilsService.toDisplayDate($ctrl.recipient.registerInformation.birthdate);
        }

        function syncDatesToRecipient() {
            $ctrl.recipient.registerInformation.birthdate = PagarmeUtilsService.toIsoDate($ctrl.birthdateDisplay);
        }

        function syncMonetaryFromRecipient() {
            $ctrl.monthlyIncomeDisplay = PagarmeUtilsService.toMonetaryDisplay($ctrl.recipient.registerInformation.monthlyIncome);
            $ctrl.annualRevenueDisplay = PagarmeUtilsService.toMonetaryDisplay($ctrl.recipient.registerInformation.annualRevenue);
        }

        function syncMonetaryToRecipient() {
            $ctrl.recipient.registerInformation.monthlyIncome = PagarmeUtilsService.toCentsModel($ctrl.monthlyIncomeDisplay);
            $ctrl.recipient.registerInformation.annualRevenue = PagarmeUtilsService.toCentsModel($ctrl.annualRevenueDisplay);
        }

        function syncBankAccountNumbersFromRecipient() {
            var bankAccount = $ctrl.recipient.bankAccount || {};
            $ctrl.branchNumberModel = {
                value: bankAccount.branchNumber,
                checkDigit: bankAccount.branchCheckDigit
            };
            $ctrl.accountNumberModel = {
                value: bankAccount.accountNumber,
                checkDigit: bankAccount.accountCheckDigit
            };
        }

        function syncBankAccountNumbersToRecipient() {
            if (!$ctrl.recipient.bankAccount) {
                $ctrl.recipient.bankAccount = {};
            }
            $ctrl.recipient.bankAccount.branchNumber = $ctrl.branchNumberModel.value;
            $ctrl.recipient.bankAccount.branchCheckDigit = $ctrl.branchNumberModel.checkDigit;
            $ctrl.recipient.bankAccount.accountNumber = $ctrl.accountNumberModel.value;
            $ctrl.recipient.bankAccount.accountCheckDigit = $ctrl.accountNumberModel.checkDigit;
        }
    }
})();
